import React from "react"
import Layout from "./src/components/layout"

export function onInitialClientRender() {
  //console.log("ReactDOM.render has executed")
}
export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>
}
